import { graphql, StaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import styled from "styled-components"
import { mixins } from "Styles"
import { theme } from "Theme"

const Wrapper = styled.section`
  background: none;
  align-items: ${(props) => (props.height == 100 ? `center` : `flex-end`)};
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    align-items: ${(props) => (props.height == 100 ? `center` : `flex-end`)};
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }

  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: inherit;
  margin: 0 auto;
  ${mixins.backgroundBefore};
`

const StyledImg = styled(GatsbyImage)`
  position: absolute !important;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`

const Content = styled.div`
  * {
    color: ${theme.colors.white.base} !important;
  }
  h2 {
    margin-bottom: 1rem;
  }
  padding: 2rem 2rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 3rem 2rem;
    h2 {
      margin-bottom: 2rem;
    }
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  align-items: flex-start;
  height: 100%;
  width: 100%;
  max-width: ${theme.layout.base};
  position: relative;
  z-index: 3;
`

class GridSectionBottomContent extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { props } = this
    const { children } = this.props

    return (
      <StaticQuery
        query={graphql`
          query {
            allImageSharp {
              edges {
                node {
                  fluid(maxWidth: 2880, quality: 90) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        `}
        render={(data) => {
          const heroImage =
            data.allImageSharp.edges.find(
              (edge) =>
                edge.node.fluid.originalName ===
                `${(props.image ? props.image : "").toString().replace(/\s+/g, "-").toLowerCase()}.jpg`
            ) || null
          return (
            <Wrapper image={heroImage}>
              {heroImage && (
                <>
                  <StyledImg
                    alt={"props.title"}
                    title={"props.title"}
                    image={heroImage.node.gatsbyImageData || {} || [] || ""}
                  />
                  <Content>{children && children}</Content>
                </>
              )}
            </Wrapper>
          )
        }}
      />
    )
  }
}

export default GridSectionBottomContent
